import * as React from 'react';
import s from './PageFooter.scss';
import { Box, Heading, Text } from 'wix-style-react';
import afnicLogo from '../../assets/images/page-footer/afnic-logo.svg';
import { useTranslation } from 'react-i18next';

export const AfnicRecommended: React.FC = () => {
  const { t } = useTranslation();
  return (
    <Box
      direction='vertical'
      align='center'
      border='1px solid transparent'
      borderTopColor='#DFE5EB'
      padding='36px'
      dataHook='afnic-recommended'
    >
      <Box marginBottom='18px'>
        <img className={s.afnicLogo} src={afnicLogo} alt='afnic'></img>
      </Box>
      <Box marginBottom='12px' fontWeight='700'>
        <Heading appearance='H3' className={s.afnicHeading}>
          {t('Advanced.Features_Values_Afnic_FR_PP_header')}
        </Heading>
      </Box>
      <Box width='590px'>
        <Text size='medium' align='center'>
          {t('Advanced.Features_Values_Afnic_FR_PP_subheader')}
        </Text>
      </Box>
    </Box>
  );
};
